var _a, _b, _c;
import { createBreakpoints, createColors } from "../theme";
import { BackgroundType } from "../components/Background";
import { sasBrandColor } from "./brandColors";
var leaderboardColors = {
    yellow: "#FFCC33",
    deepYellow: "#D9A30B",
    lightYellow: "#FFE86F"
};
var brand2025Colors = {
    yellow: "#F5C751",
    lightYellow: "#F7D378",
    chatLight: "#C4DEFD",
    chatDark: "#0664D0",
    darkAccent: "#132665",
    dashboardBG: "#033772",
    lightBlue: "#E1EFFE",
};
var TeamInfos = {
    first: {
        name: "yellow",
        main: "#937731",
        lightBG: "#F5C751",
        mediumBG: "#F5C751",
        darkBG: "#F5C751", // Background for Leaderboard Row
    },
    second: {
        name: "red",
        main: "#995959",
        lightBG: "#FF9494",
        mediumBG: "#FF9494",
        darkBG: "#FF9494",
    },
    third: {
        name: "blue",
        main: "#466b97",
        lightBG: "#74B3FB",
        mediumBG: "#74B3FB",
        darkBG: "#74B3FB",
    },
    fourth: {
        name: "green",
        main: "#467a49",
        lightBG: "#75CC7A",
        mediumBG: "#75CC7A",
        darkBG: "#75CC7A",
    }
};
export var brand2025 = {
    host: {
        create: {
            errorColor: "#F44336",
        },
        game: {
            pauseColor: "#F44336",
        },
    },
    welcome: {
        welcomeText: { color: sasBrandColor.lightBlue },
        subtitle: {
            color: sasBrandColor.lightBlue
        },
        footer: {
            color: brand2025Colors.lightBlue,
            sponsor: {
                src: "/assets/logos/brand2025/aws-logo.svg",
            }
        },
        instructions: {
            instructionBorder: "1px solid ".concat(sasBrandColor.mediumBlue),
            circleColor: brand2025Colors.yellow,
            teamNoIcon: true,
            small: {
                src: "/assets/instructions/brand2025/instructions-small.jpeg",
                countdown: {
                    label: {
                        top: -1,
                        left: 118,
                    },
                    text: {
                        top: 5,
                        left: 10
                    }
                },
                submit: {
                    label: {
                        top: 195,
                        left: 100
                    },
                    text: {
                        top: 210,
                        left: 10
                    }
                }
            },
            other: {
                countdown: {
                    label: {
                        top: 14,
                        left: 388,
                    },
                    text: {
                        top: 33,
                        left: 0,
                    }
                },
                submit: {
                    label: {
                        top: 199,
                        left: 248
                    },
                    text: {
                        top: 227,
                    }
                }
            },
            large: {
                src: "/assets/instructions/brand2025/instructions-large.jpeg",
                countdown: {
                    label: {
                        top: 13,
                        left: 222
                    },
                    text: {
                        top: 6,
                        left: 0,
                    }
                },
                submit: {
                    label: {
                        top: 110,
                        left: 138
                    },
                    text: {
                        top: 118,
                    }
                }
            },
        },
        actionButton: {
            border: "none",
            textTransform: "none",
            color: sasBrandColor.black,
            bgColor: brand2025Colors.yellow,
            width: 120,
            lighten: true,
            fontWeight: 700,
        },
        textField: {
            bgColor: sasBrandColor.white,
            bgHoverColor: "#f4f4f6",
            textColor: sasBrandColor.black,
            labelColor: "#6C7689",
            errorColor: brand2025Colors.yellow,
            width: 300,
        },
        gameCountdownColor: brand2025Colors.lightYellow,
    },
    background: {
        backgroundImage: {
            large: (_a = {},
                _a[BackgroundType.Welcome] = "url('/assets/backgrounds/brand2025/bg-large-welcome.jpg')",
                _a[BackgroundType.GetStarted] = "url('/assets/backgrounds/brand2025/bg-large-welcome.jpg')",
                _a[BackgroundType.Main] = "linear-gradient(180deg, #5232E8 0%, #0767D4 100%)",
                _a[BackgroundType.ThankYou] = "url('/assets/backgrounds/brand2025/bg-large-thankyou.svg')",
                _a),
            small: (_b = {},
                _b[BackgroundType.Welcome] = "url('/assets/backgrounds/brand2025/bg-small-welcome.jpg')",
                _b[BackgroundType.GetStarted] = "url('/assets/backgrounds/brand2025/bg-small-welcome.jpg')",
                _b[BackgroundType.Main] = "linear-gradient(180deg, #5232E8 0%, #0767D4 100%)",
                _b[BackgroundType.ThankYou] = "url('/assets/backgrounds/brand2025/bg-small-thankyou.svg')",
                _b),
        },
        backgroundColor: (_c = {},
            _c[BackgroundType.Welcome] = sasBrandColor.sasBlue,
            _c[BackgroundType.GetStarted] = sasBrandColor.sasBlue,
            _c[BackgroundType.Main] = sasBrandColor.sasBlue,
            _c[BackgroundType.ThankYou] = sasBrandColor.sasBlue,
            _c)
    },
    gameComplete: {
        //Future theming note: with future themes, may need to consider fully theming decorative circles
        decorativeCircles: false,
        thankYouTextColor: "white",
        background: "linear-gradient(180deg, #5232E8 0%, #0767D4 100%)",
    },
    presenterVideo: {
        background: sasBrandColor.midnightBlue,
        muteBackground: sasBrandColor.lightBlue,
        textBackground: sasBrandColor.lightBlue,
    },
    questionPrompt: {
        background: brand2025Colors.darkAccent,
        timerColor: sasBrandColor.white,
        timeRemainderColor: brand2025Colors.yellow,
        delayedColor: "#7F88F1",
    },
    questionExplanation: {
        //Using RGB to get opacity right
        backgroundColor: "rgb(4, 47, 99, 0.5)"
    },
    multipleChoice: {
        multipleChoiceColors: {
            first: "#0770E9",
            second: "#0770E9",
            third: "#0770E9",
            fourth: "#0770E9",
            disabled: "#446499"
        },
        feedbackColor: brand2025Colors.lightBlue
    },
    phrase: {
        foregroundColor: "#C4DEFD",
        foregroundFocusColor: "#6C7689"
    },
    questionSubmit: {
        border: "none",
        borderRadius: 24,
        background: brand2025Colors.yellow,
        icon: undefined,
        foreground: sasBrandColor.black,
        fontWeight: 700,
        matchInlineStyle: true,
    },
    questionProgress: {
        box: {
            color: brand2025Colors.lightBlue
        },
        pastBox: {
            backgroundColor: brand2025Colors.darkAccent,
            color: brand2025Colors.chatLight,
        },
        currentBox: {
            backgroundColor: brand2025Colors.yellow,
        }
    },
    chat: {
        inputBorder: "2px solid white",
        scrollBar: sasBrandColor.lightBlue,
        background: {
            focused: brand2025Colors.darkAccent,
            unfocused: brand2025Colors.darkAccent,
        },
        colorDark: brand2025Colors.chatDark,
        colorLight: brand2025Colors.chatLight,
        nicknameFontWeight: 700,
        sendButton: {
            icon: "/assets/icons/brand2025/chat-input.svg",
            background: sasBrandColor.white
        },
    },
    teamInfos: TeamInfos,
    accessoryPanel: {
        background: brand2025Colors.darkAccent,
        textColor: brand2025Colors.chatLight,
        expandButton: {
            largeButton: true,
            desktop: {
                chevron: {
                    src: "/assets/accessory/brand2025/expand-desktop.png",
                    srcSet: "/assets/accessory/brand2025/expand-desktop.png, /assets/accessory/brand2025/expand-desktop@2x.png 2x"
                },
                chevronWarning: {
                    src: "/assets/accessory/brand2025/expand-desktop-glow.png",
                    srcSet: "/assets/accessory/brand2025/expand-desktop-glow.png, /assets/accessory/brand2025/expand-desktop-glow@2x.png 2x"
                }
            },
            mobile: {
                expand: {
                    src: "/assets/accessory/brand2025/expand-mobile.png",
                    srcSet: "/assets/accessory/brand2025/expand-mobile.png, /assets/accessory/brand2025/expand-mobile@2x.png 2x"
                },
                expandGlow: {
                    src: "/assets/accessory/brand2025/expand-mobile-glow.png",
                    srcSet: "/assets/accessory/brand2025/expand-mobile-glow.png, /assets/accessory/brand2025/expand-mobile-glow@2x.png 2x"
                }
            }
        },
        tabs: {
            background: "#2D4DDE",
            mobileBackground: brand2025Colors.darkAccent,
            tabSelector: "3px solid white",
            textColor: sasBrandColor.white,
            largeTabSize: true
        },
        participantCounter: "squares",
        leaderboard: {
            removeBackgroundSVG: true,
            teamAverage: {
                color: sasBrandColor.black
            },
            rankChange: {
                down: "#ff5c5c",
                up: "#63c568"
            },
            row: {
                borderWidth: 0,
                rankedStreakSVG: "/assets/leaderboard/brand2025/hot-streak.svg",
                unrankedStreakSVG: "/assets/leaderboard/brand2025/hot-streak.svg",
                leaderboardTiles: true,
                regularPlayer: {
                    rankedColor: sasBrandColor.white,
                    unrankedColor: sasBrandColor.white,
                    team: {
                        rankedColor: sasBrandColor.black,
                        unrankedColor: sasBrandColor.black,
                    },
                },
                currentPlayer: {
                    borderWidth: "2px 0 2px 2px",
                    borderColor: sasBrandColor.white,
                    unrankedColor: sasBrandColor.white,
                    rankedColor: sasBrandColor.white,
                    rankChangeUnrankedColor: sasBrandColor.white,
                    rankChangeRankedColor: sasBrandColor.white,
                    team: {
                        unrankedColor: sasBrandColor.black,
                        rankedColor: sasBrandColor.black,
                        rankChangeUnrankedColor: sasBrandColor.black,
                        borderColor: "#E2EEFF",
                        rankChangeRankedColor: sasBrandColor.black,
                    },
                },
            },
            scorePill: {
                showBorder: false
            },
            rank: {
                showBorder: false
            },
            firstPlace: {
                backgroundColor: "#5232E8",
                highlightColor: sasBrandColor.white,
                borderColor: sasBrandColor.white
            },
            secondPlace: {
                backgroundColor: "#2D4DDE",
                highlightColor: sasBrandColor.white,
                borderColor: sasBrandColor.white
            },
            thirdPlace: {
                backgroundColor: "#0767D4",
                highlightColor: sasBrandColor.white,
                borderColor: sasBrandColor.white
            },
            default: {
                borderColor: "none",
                backgroundColor: "#446499",
            }
        },
        dashBoard: {
            simpleDashboard: true,
            sectionTitleColor: "#C4DEFD",
            background: "#09214c",
            lineChart: {
                background: brand2025Colors.dashboardBG,
                svgBackground: "transparent linear-gradient(179deg, ".concat(brand2025Colors.dashboardBG, " 0%, ").concat(brand2025Colors.dashboardBG, " 100%) 0% 0% no-repeat padding-box"),
                currentPlayer: {
                    color: sasBrandColor.mediumBlue
                },
                hoverPlayer: {
                    color: sasBrandColor.lightBlue
                }
            },
            maxCorrect: {
                background: brand2025Colors.dashboardBG,
                highlightColor: "#FFCC33"
            },
            gauge: {
                background: brand2025Colors.dashboardBG,
                gaugeSVGPath: "/assets/dashboard/brand2025/gauge.svg",
                needleSVGPath: "/assets/dashboard/brand2025/needle.svg"
            },
            streak: {
                fireSVGPath: "/assets/dashboard/brand2025/streak.svg",
                streakNumberColor: brand2025Colors.dashboardBG
            },
            questionSummary: {
                background: brand2025Colors.dashboardBG,
                correct: {
                    answeredTextColor: sasBrandColor.black,
                    backgroundColor: "#61A8FA"
                },
                incorrect: {
                    answeredTextColor: sasBrandColor.black,
                    backgroundColor: brand2025Colors.yellow
                }
            },
            averageTime: {
                stopWatchSVGPath: "/assets/dashboard/brand2025/stopwatch.svg",
                host: {
                    timeColor: sasBrandColor.white,
                    background: brand2025Colors.dashboardBG,
                },
                player: {
                    timeColor: sasBrandColor.white,
                    background: brand2025Colors.dashboardBG,
                }
            }
        },
    },
    breakpoints: createBreakpoints({
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1367
        }
    }),
    color: createColors(sasBrandColor.sasBlue, sasBrandColor.midnightBlue, "#E4E9EC", leaderboardColors.yellow),
};
//# sourceMappingURL=brand2025.js.map